import { reviews } from "@/mocks/reviews";

const TRUST_ITEMS = [
  {
    icon: "ri-translate-2",
    title: "한국어 소통 100%",
    desc: "예약 문의부터 체크인, 긴급 상황까지 모든 소통이 한국어로 가능합니다.",
    color: "text-amber-500",
    bg: "bg-amber-50",
  },
  {
    icon: "ri-door-lock-line",
    title: "비대면 체크인 지원",
    desc: "스마트 도어락 시스템으로 비대면 체크인 가능. 늦은 도착도 걱정 없어요.",
    color: "text-green-500",
    bg: "bg-green-50",
  },
  {
    icon: "ri-kakao-talk-fill",
    title: "카카오톡 실시간 상담",
    desc: "카카오톡으로 언제든 실시간 상담 가능. 현지 맛집부터 응급상황까지 즉시 대응.",
    color: "text-yellow-500",
    bg: "bg-yellow-50",
  },
  {
    icon: "ri-shield-check-line",
    title: "안전 검증 완료",
    desc: "모든 숙소는 한울이 직접 방문하여 청결, 안전, 편의시설을 사전 검증했습니다.",
    color: "text-rose-500",
    bg: "bg-rose-50",
  },
  {
    icon: "ri-map-pin-line",
    title: "현지 맛집 정보 제공",
    desc: "호스트가 직접 추천하는 숨겨진 로컬 맛집, 카페, 야타이 정보를 무료 제공.",
    color: "text-violet-500",
    bg: "bg-violet-50",
  },
  {
    icon: "ri-heart-pulse-line",
    title: "응급 상황 지원",
    desc: "24시간 긴급 연락 가능. 병원 동행, 약국 안내, 통역 지원까지 책임집니다.",
    color: "text-blue-500",
    bg: "bg-blue-50",
  },
];

export default function TrustBuilderSection() {
  return (
    <section id="trust" className="py-12 sm:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Header */}
        <div className="text-center mb-10 sm:mb-14">
          <div className="inline-flex items-center gap-2 text-amber-600 text-xs font-semibold tracking-widest uppercase mb-3">
            <i className="ri-heart-line"></i>
            TRUST BUILDER
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-stone-800 mb-3">
            안심하고 여행하세요
          </h2>
          <p className="text-stone-500 text-sm max-w-lg mx-auto leading-relaxed">
            한국인 호스트이기 때문에 가능한 세심한 배려.
            투숙객 1,200명이 검증한 한울만의 신뢰 요소입니다.
          </p>
        </div>

        {/* Trust Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5 mb-14 sm:mb-20">
          {TRUST_ITEMS.map((item) => (
            <div
              key={item.title}
              className="p-5 sm:p-6 rounded-2xl border border-stone-100 hover:border-amber-200 transition-colors group"
            >
              <div className={`w-10 h-10 sm:w-11 sm:h-11 flex items-center justify-center rounded-xl ${item.bg} ${item.color} mb-3 sm:mb-4 group-hover:scale-110 transition-transform`}>
                <i className={`${item.icon} text-lg sm:text-xl`}></i>
              </div>
              <h3 className="font-bold text-stone-800 text-sm mb-2">{item.title}</h3>
              <p className="text-xs text-stone-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        {/* Reviews */}
        <div>
          <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-6 sm:mb-8 gap-3">
            <div>
              <h3 className="text-lg sm:text-xl font-bold text-stone-800 mb-1">실제 투숙객 후기</h3>
              <p className="text-xs text-stone-400">에어비앤비 실제 투숙 후기 발췌</p>
            </div>
            <div className="flex items-center gap-2 bg-amber-50 border border-amber-200 rounded-xl px-4 py-2 self-start sm:self-auto">
              <i className="ri-star-fill text-amber-500 text-sm"></i>
              <span className="font-bold text-stone-800 text-sm">4.96</span>
              <span className="text-stone-400 text-xs">/ 5.0 평균</span>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5">
            {reviews.map((review) => (
              <div key={review.id} className="bg-stone-50 rounded-2xl p-4 sm:p-5 border border-stone-100">
                <div className="flex items-center gap-3 mb-3 sm:mb-4">
                  <div className="w-10 h-10 rounded-full overflow-hidden shrink-0">
                    <img src={review.avatar} alt={review.name} className="w-full h-full object-cover object-top" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-1 sm:gap-2 flex-wrap">
                      <span className="font-semibold text-stone-800 text-sm">{review.name}</span>
                      <span className="text-xs text-stone-400">· {review.location}</span>
                    </div>
                    <div className="flex items-center gap-0.5 mt-0.5">
                      {Array.from({ length: review.rating }).map((_, i) => (
                        <i key={i} className="ri-star-fill text-amber-400 text-xs"></i>
                      ))}
                    </div>
                  </div>
                  <span className="text-xs text-stone-400 shrink-0">{review.date}</span>
                </div>
                <p className="text-xs sm:text-sm text-stone-600 leading-relaxed mb-3">"{review.text}"</p>
                <div className="text-xs text-amber-600 bg-amber-50 px-3 py-1 rounded-full inline-block">
                  <i className="ri-building-line mr-1"></i>{review.accommodation}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
